import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static colorBlock = document.getElementById('color-block');
  static colorSelect = document.getElementById('color-select');
  
  initialize() {
    let colorSelect = document.getElementById('color-select');
    let colorBlock = document.getElementById('color-block');
    let text = colorSelect.options[colorSelect.selectedIndex].text;
    colorBlock.classList.add("!bg-frankly-" + text);
  }

  changeColor(event){
    let colorSelect = document.getElementById('color-select');
    let colorBlock = document.getElementById('color-block');
    const text = colorSelect.options[colorSelect.selectedIndex].text;

    const classes = colorBlock.className.split(/\s+/);
    let newClasses = classes.filter(className => !/^!bg-frankly-/.test(className));
    colorBlock.className = newClasses.join(' ');
    colorBlock.classList.add("!bg-frankly-" + text);
  }
}